<template>
  <div class="rs-enroll-container">
    <div class="content">
      <div class="card">
        <van-form class="form" @submit="onSubmit">
          <van-cell-group inset>
          <van-field required name="小记者照片" label="小记者照片">
            <template #input>
              <div class="uploader" style="padding-bottom: 50px">
                <div style="display: flex; height: 300px;">
                  <van-uploader v-model="form1.authorPhoto" accept="image/*" upload-icon="plus" max-count="1"
                    :max-size="10 * 1024 * 1024" :after-read="onAuthorPhotoAfterRead"
                    :before-delete="onAuthorPhotoDelete" />
                  <div class="case">
                    <img class="img-case" src="../../../../public/static/images/activity/reporter/case.png" alt="">
                    <span class="img-case-txt">照片示例</span>
                  </div>
                </div>
                <div class="tip">请上传一寸免冠证件照，尺寸宽295px×高413px，格式JPG或PNG，分辨率300dpi，大小不超过500KB。</div>
              </div>
            </template>
          </van-field>
          <van-field required v-model="form1.name" name="姓名" label="姓名" placeholder="请输入姓名" :rules="rules.name" />
          <van-field required readonly v-model="form1.sex" name="性别" label="性别" placeholder="请选择性别" :rules="rules.sex"
            @click="sexPickerVisible = true" />
          <van-field required v-model="form1.birthday" label="出生日期" placeholder="请选择出生日期" readonly
            :rules="rules.birthday" @click="showDatePickerVisible" />
          <van-field required v-model="form1.city" name="所在地区" label="所在地区" placeholder="请选择省市" :rules="rules.city"
            readonly @click="showCascader = true" />
          <van-field required v-model="form1.height" name="身高" label="身高" placeholder="单位cm" :maxlength="4"
            :rules="rules.height" />
          <van-field required v-model="form1.weight" name="体重" label="体重" placeholder="单位kg" :rules="rules.weight"
            :maxlength="3" />
          <!-- <van-field v-model="form1.sclass" name="班级" label="班级" placeholder="请填写班级" /> -->
          <van-field v-model="form1.contacts" name="监护人姓名" label="监护人姓名" :maxlength="4" placeholder="请输入监护人姓名" required
            :rules="rules.contacts" />
          <van-field required v-model="form1.mobile" name="手机号" label="手机号" placeholder="请填写联系人手机号"
            :rules="rules.mobile"/>
          <div class="tip" style="margin-top: 20px;margin-left: 200px;">学习小记者课程需使用该手机号登录。</div>
          <!-- 短信验证 -->
          <van-field required v-model="smsCode" name="验证码" label="验证码" placeholder="请填写短信验证码" :rules="rules.smsCode">
            <template #button>
              <van-button size="small" type="primary" @click="getSmsCode" :disabled="smsCodeTime > 0">
                获取验证码{{ smsCodeTime > 0 ? `(${smsCodeTime}s)` : "" }}
              </van-button>
            </template>
          </van-field>
          <van-field required v-model="form1.school" name="就读学校" label="就读学校" placeholder="请填写全称，不可填写简称"
            :rules="rules.school" />
          <van-field required v-model="form1.myDetail" name="自我介绍" label="自我介绍" type="textarea" rows="2" autosize
            maxlength="100" show-word-limit placeholder="请填写自我介绍，100个字以内" :rules="rules.myDetail" />
          <van-field required v-model="form1.organization" name="推荐单位" label="推荐单位" placeholder="请填写全称，没有则填“无”"
            :rules="rules.organization" />
          <van-field required v-model="form1.address" name="邮寄地址" label="邮寄地址" type="textarea" rows="2" autosize
            maxlength="100" show-word-limit placeholder="请按照省、市、区、街道、详细地址的格式填写" :rules="rules.address" />
          <div style="margin-top: 20px;">
            <p style="font-size: 24px; font-weight: bold;">
              <span style="color: red;">*</span>
              <span>以上信息填写完需阅读并同意以下承诺书</span>
            </p>
            <p style="margin: 20px 0; font-size: 18px; line-height: 1.5; text-indent: 2em;">
              我自愿申请加入光明小记者，并承诺遵守小记者管理中心的各项规章制度。
              我将积极参与中心组织的各项活动，通过实践学习，提高自己的新闻采编能力。
              同时，我也会努力学习相关知识，拓宽视野，以更好地理解社会现象，提升报道的深度和广度。
            </p>
            <van-radio-group v-model="checked">
              <van-radio name="1" shape="square" style="font-size: 20px;">已阅读并同意承诺书条款</van-radio>
            </van-radio-group>
          </div>


          <div class="submit-button-warp">
            <van-button class="submit-button" type="primary" native-type="submit">
              提交
            </van-button>
          </div>
          </van-cell-group>
        </van-form>
        <van-popup v-model:show="sexPickerVisible" position="bottom">
          <van-picker :columns="sexList" @confirm="onSexConfirm" @cancel="sexPickerVisible = false" item-height="80" />
        </van-popup>
        <van-popup v-model:show="showCascader" position="bottom">
          <van-cascader :options="cityList" title="请选择城市" @finish="onFinish" @close="showCascader = false"
            item-height="80" />
        </van-popup>
        <van-popup v-model:show="datePickerVisible" round position="bottom">
          <van-datetime-picker type="date" title="出生日期" v-model="birthday" :item-height="60" :min-date="minDate" :max-date="maxDate"
            @cancel="datePickerVisible = false" @confirm="onDatePickerConfirm" />
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import pattern from "@/utils/pattern"
import api_common from "@/assets/api/api_common"
import api_activity from "@/assets/api/api_activity"
import { Dialog, Notify } from "vant"
import { AuthMixin } from "@/assets/utils/mixin"
import CityList from "./city.json"
import dayjs from "dayjs";

// eslint-disable-next-line no-undef

export default {
  // "最美红色故事发声人"视频、征文报名
  mixins: [AuthMixin],
  name: "wxcarnivalReporterApply",
  data() {
    return {
      type: 0,
      form1: {},
      smsCode: '',
      smsCodeTime: 0,
      smsCodeTimer: null,
      minDate: new Date(1949, 0, 1),
      maxDate: new Date(),
      birthday: new Date(),
      checked: '',
      rules: {
        authorPhoto: [{ required: true, message: "小记者照片不能为空" }],
        name: [{ required: true, message: "姓名不能为空" }],
        sex: [{ required: true, message: "性别不能为空" }],
        birthday: [{ required: true, message: "出生日期不能为空" }],
        city: [{ required: true, message: "所在地区不能为空" }],
        age: [{ required: true, message: "组别不能为空" }],
        myDetail: [{ required: true, message: "自我介绍不能为空" }],
        height: [{ required: true, message: "身高不能为空" }],
        weight: [{ required: true, message: "体重不能为空" }],
        contacts: [{ required: true, message: "监护人不能为空" }],
        mobile: [
          { required: true, message: "手机号不能为空" },
          { pattern: pattern.mobile, message: "手机号格式错误" },
        ],
        smsCode: [{ required: true, message: "验证码不能为空" }],
        school: [{ required: true, message: "就读学校不能为空" }],
        organization: [{ required: true, message: "推荐单位不能为空" }],
        address: [{ required: true, message: "邮寄地址不能为空" }],
      },
      showPicker: false,
      showCascader: false,
      sexPickerVisible: false,
      datePickerVisible: false,
      cityList: CityList,
      sexList: ["男", "女"],
      // eslint-disable-next-line no-undef
      uploader: new AliyunUpload.Vod({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: "cn-shanghai",
        userId: "12312312312413",
        // 添加文件成功
        addFileSuccess: this.handleAddFileSuccess,
        // 开始上传
        onUploadstarted: this.handleOnUploadstarted,
        // 文件上传成功
        onUploadSucceed: this.handleOnUploadSucceed,
        // 文件上传失败
        onUploadFailed: this.handleOnUploadFailed,
        // 取消文件上传
        onUploadCanceled: this.handleOnUploadCanceled,
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: this.handleOnUploadProgress,
        // 上传凭证超时
        onUploadTokenExpired: this.handleOnUploadTokenExpired,
        // 全部文件上传结束
        onUploadEnd: this.handleOnUploadEnd,
      }),
    }
  },
  methods: {
    showDatePickerVisible() {
      this.datePickerVisible = true
    },
    onAuthorPhotoDelete() {
      this.form1.authorPhoto = ""
      return true
    },
    onDatePickerConfirm(date) {
      this.form1.birthday = dayjs(date).format("YYYY-MM-DD");
      this.datePickerVisible = false;
    },
    countdown() {
      this.smsCodeTime = 60
      this.smsCodeTimer = setInterval(() => {
        this.smsCodeTime--
        if (this.smsCodeTime <= 0) {
          clearInterval(this.smsCodeTimer)
        }
      }, 1000)
    },
    // 发送验证码
    getSmsCode() {
      const params = { mobile: this.form1.mobile };
      if (!params.mobile) {
        Notify({ type: "danger", message: "请输入手机号" })
        return;
      }
      if (
        !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[\d]))\d{8}$/.test(
          params.mobile
        )
      ) {
        Notify({ type: "danger", message: "手机号格式错误" })
        return;
      }
      api_activity.getVerifyCode(params).then((res) => {
        if (res.errcode !== 0) {
          Notify({ type: "danger", message: res.errmsg })
          return;
        }
        this.countdown();
      });
    },
    // 校验验证码
    async checkSmsCode() {
      let params = {
        mobile: this.form1.mobile,
        verifyCode: this.smsCode
      }
      let res = await api_activity.queryCode(params)
      if (res.data && res.data.isLogin) {
        return true
      }
      Notify({ type: "danger", message: "验证码有误，请确认后重试" })
      return false
    },
    onSexConfirm(val) {
      this.form1.sex = val
      this.sexPickerVisible = false
    },
    onPickerConfirm(val) {
      this.form1.age = val
      this.showPicker = false
    },
    // 选择器确认
    onFinish(e) {
      const { selectedOptions, value } = e;
      // const fieldValue = selectedOptions
      //     .map((option) => option.text || option.name)
      //     .join('/');
      this.form1.city = value
      this.showCascader = false
    },
    // 表单提交
    async onSubmit() {
      let params = {}
      if (this.checked !== '1') {
        Notify({ type: "danger", message: "请同意承诺书条款" })
        return
      }
      if (!this.smsCode) {
        Notify({ type: "danger", message: "请输入验证码" })
        return
      }
      const check = await this.checkSmsCode()
      if (!check) {
        return
      }
      const authorPhoto = this.form1.authorPhoto?.[0]?.url || ''
      if (!authorPhoto) {
        Notify({ type: "danger", message: "提交失败，小记者照片不能为空" })
        return
      }
      params = {
        type: this.type,
        name: this.form1.name,
        mobile: this.form1.mobile,
        school: this.form1.school,
        content: JSON.stringify({ ...this.form1, authorPhoto }),
      }

      api_activity.addReporterNew(params).then((res) => {
        if (res.errcode !== 0) {
          Notify({ type: "danger", message: res.errmsg })
          return
        }
        if (!res.data) {
          Notify({ type: "danger", message: '提交失败，请联系工作人员处理' })
          return
        }
        Dialog.alert({
          title: "提示",
          message: "您的申请已提交",
        }).then(() => {
          this.form1 = {}
          // localStorage.removeItem('form1');
        })
      })
    },
    // 视频上传前
    onVideoBeforeRead(file) {
      if (file.type !== "video/mp4" && file.type !== "video/mov" && file.type !== "video/quicktime") {
        Notify({ type: "danger", message: "作品格式错误 " })
        return false
      }
      return true
    },
    // 上传视频文件
    async onVideoAfterRead(file) {
      file.status = "uploading"
      file.message = "上传中..."
      this.uploader.addFile(file.file, null, null, null, '{"Vod":{}}')
    },
    // 删除视频文件
    onVideoDelete() {
      this.form1.videoId = ""
      return true
    },
    // 上传小记者照片
    onAuthorPhotoAfterRead(file) {
      file.status = "uploading"
      file.message = "上传中..."
      api_common.uploadImage(file.file).then((res) => {
        if (res.errcode === 0) {
          file.status = "success"
          file.message = "上传成功"
          file.url = "https://wxfactory.zhmobi.com" + res.url
        } else {
          file.status = "failed"
          file.message = "上传失败"
          file.url = ""
        }
      })
    },
    // 上传作品照片
    onFilesAfterRead(files) {
      let tmpFiles = files
      if (!(files instanceof Array)) {
        tmpFiles = [files]
      }
      tmpFiles.forEach((file) => {
        file.status = "uploading"
        file.message = "上传中..."
        let upload = api_common.uploadImage
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 5000);
        console.log('file', file)
        const extension = file.file.name.split('.').pop(); // 获取文件后缀
        if (extension === 'docx' || extension === 'doc') {
          upload = api_common.uploadFile
        }
        upload(file.file).then((res) => {
          if (res.errcode === 0) {
            file.status = "success"
            file.message = "上传成功"
            file.url = "https://wxfactory.zhmobi.com" + res.url
          } else {
            file.status = "failed"
            file.message = "上传失败"
            file.url = ""
          }
        })
      })
    },
    // 删除作品
    onFilesDelete() {
      return true
    },
    // 视频添加成功回调
    handleAddFileSuccess() {
      this.uploader.startUpload()
    },
    // 视频开始上传回调
    async handleOnUploadstarted(uploadInfo) {
      if (!uploadInfo.videoId) {
        const params = { CateId: "1000425120", FileName: uploadInfo.file.name }
        const res = await api_common.createUploadVideo(params)
        if (res.errcode !== 0) {
          return
        }
        this.uploader.setUploadAuthAndAddress(
          uploadInfo,
          res.data.UploadAuth,
          res.data.UploadAddress,
          res.data.VideoId
        )
      }
    },
    // 视频上传成功回调
    handleOnUploadSucceed(uploadInfo) {
      const url = "视频作品"
      const videoId = uploadInfo.videoId
      this.form1.worksUrl = [{ url, status: "success", message: "上传成功" }]
      this.form1.videoId = videoId
    },
    // 视频上传失败回调
    handleOnUploadFailed(uploadInfo, code, message) {
      console.log("handleOnUploadFailed", uploadInfo, code, message)
    },
    // 视频上传取消回调
    handleOnUploadCanceled(uploadInfo, code, message) {
      console.log("handleOnUploadCanceled", uploadInfo, code, message)
    },
    // 视频上传进度回调
    handleOnUploadProgress(uploadInfo, totalSize, progress) {
      console.log(progress)
    },
    // 视频上传凭证超时回调
    handleOnUploadTokenExpired(uploadInfo) {
      console.log("handleOnUploadTokenExpired", uploadInfo)
    },
    // 视频上传完成回调
    handleOnUploadEnd(uploadInfo) {
      console.log("handleOnUploadEnd", uploadInfo)
    },
    // 年月格式化
    // formatter(type, val) {
    //     if (type === "year") {
    //         return `${val}年`;
    //     } else if (type === "month") {
    //         return `${val}月`;
    //     }
    //     return val;
    // },
  },
  mounted() {
    this.initWxConfig({
      itemName: "“光明小记者嘉年华”视频、征文报名",
      desc: "光明小记者嘉年华”视频、征文报名",
      pic: "https://xst.olomobi.com/img/top.66b4c33c.jpg",
      link: `activity/carnival/enroll`,
    })
  },
  // created() {
  //     const cached1 = localStorage.getItem('form1');
  //     if (cached1) {
  //         this.form1 = JSON.parse(cached1);
  //     }
  // },
  // watch:{
  //    form1: {
  //         handler(newVal) {
  //             localStorage.setItem('form1', JSON.stringify(newVal));
  //         },
  //         deep: true
  //     },
  // }
}
</script>
<style lang="less" scoped>
.rs-enroll-container {
  // @media (max-width: 700px) {
    // min-width: auto;
    // 按屏幕比例缩小
    // transform: scale(0.7); /* 缩放为原来的80% */
    // transform-origin: center top; /* 从左上角开始缩放 */
  // }
  .banner {}

  .content {
    margin: 0px;
    margin-top: -4px;
    background-color: #56b0fe;
    padding: 20px;

    .card {
      background-color: white;
      border-radius: 10px;
      padding: 20px;

      .uploader {
        position: relative;
        width: 100%;
        padding-bottom: 140px;

        .case {
          position: relative;

          .img-case {
            width: 150px;
          }

          .img-case-txt {
            position: absolute;
            right: 0px;
            bottom: 90px;
            width: 150px;
            text-align: center;
            color: #ccc;
            background-color: #cccccc70;
          }
        }

        .tip {
          position: absolute;
          bottom: 0px;
          font-size: 20px;
          line-height: 1.5;
          color: gray;
          margin: 0px;
        }
      }

      .submit-button-warp {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;

        .submit-button {
          width: 300px;
          border-radius: 10px;
          background-color: #56b0fe;
          border-color: #56b0fe;
        }
      }
    }
  }
}

label {
  font-size: 24px;
}
</style>

<style>
.van-tabs__nav--card {
  margin: 0 !important;
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #56b0fe;
}
</style>
